import React from 'react';

import { useAreaUnits } from '$contexts/area-units';
import BaseSelect from '$partials/fields/select.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/ui.d.ts').AreaUnitsSelector}
 */
const AreaUnitsSelector = ({
    className
}) => {
    const { unit, setUnit } = useAreaUnits() || {};

    const areaOptions = [
        { label: 'sqm', value: 'sqm' },
        { label: 'sqft', value: 'sqft' },
    ];

    return (
        <BaseSelect
            displayValue={areaOptions.find((opt) => opt.value === unit)?.label}
            name='currency'
            onChange={(unit) => setUnit(unit)}
            options={areaOptions}
            triggerClassName={className}
            value={unit} />
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default AreaUnitsSelector;
